import { Link } from "react-router-dom";

export const Logo = ({ size = "md" }) => {
  const cls = size === "lg" ? "text-2xl" : "text-lg";
  return (
    <Link to="/" data-testid="logo-link" className="flex items-center gap-2 group">
      <span className="relative inline-flex h-7 w-7 items-center justify-center rounded-full gradient-pink-cyan glow-pink">
        <span className="absolute inset-[2px] rounded-full bg-black"></span>
        <span className="relative font-display font-black text-white text-xs">V</span>
      </span>
      <span className={`font-display font-black tracking-tight ${cls} text-gradient`}>
        VYBE
      </span>
    </Link>
  );
};
